/* RESPONSIBLE TEAM: team-automation-foundations */

import IntercomRoute from 'embercom/routes/base/intercom-route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentEcommerceGuidanceShowRoute extends IntercomRoute {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentEcommerceGuidanceShowRoute, {
  overrideRenderTemplate: false,
});
